//-Свернуть-развернуть текстовый блок
//-На текстовый блок вешаем data-cut-text со значением, которое будет соответсвовать значению кнопки data-cut

export default function cutText() {
    const textBlocks = document.querySelectorAll("[data-cut-text]")
    const btns = document.querySelectorAll("[data-cut]")

    if (textBlocks || btns) {
        btns.forEach(btn =>{
            const btnText = btn.textContent;

            btn.addEventListener('click', (event)=>{
                
                event.preventDefault()

                textBlocks.forEach(block =>{
                    
                    if(block.dataset.cutText == btn.dataset.cut){
                        block.classList.toggle('open')
                        btn.classList.toggle('open')
                    }
                    // if (block.classList.contains("open")) {
                    //     block.style.height = `${block.scrollHeight}px`
                    // } else {
                    //     block.style.height = `auto`
                    // }
                })

                if(btn.classList.contains('open')){
                    btn.innerHTML = 'Свернуть'
                } else{
                    btn.innerHTML = btnText
                }
            })
        })
    }
    
}



// WEBPACK FOOTER //
// ./src/js/new-design/cutText.js